export default __webpack_public_path__ + "static/media/arrow-up.7ddd3835.svg";